<ng-content />
<ng-content select="[counter]" />
